"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.footerClasses = void 0;
// istanbul ignore file: doesn't hold any logic
const Footer_1 = __importDefault(require("./Footer"));
var styles_1 = require("./styles");
Object.defineProperty(exports, "footerClasses", { enumerable: true, get: function () { return styles_1.classes; } });
exports.default = Footer_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZm9vdGVyL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLCtDQUErQztBQUMvQyxzREFBOEI7QUFROUIsbUNBQW9EO0FBQTNDLHVHQUFBLE9BQU8sT0FBaUI7QUFFakMsa0JBQWUsZ0JBQU0sQ0FBQyJ9